var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-pagination", {
    attrs: {
      background: "",
      size: _vm.size,
      "current-page": _vm.currentPage,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.limit,
      layout: _vm.layout,
      total: _vm.total,
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }